import React, { useEffect } from 'react';
import { getDashboardCards, getTodaysDate } from './homePageHelpers.js';
import { messageManager } from '../System/messageManager/messageManager.js';
import HomePageCard from './HomePageCard.js';
import { ForgeScaffold } from '@tylertech/forge-react';
import { getOrganizationAccessIcons } from '../../services/userService.js';
import { getAccessCondition } from '../reusable/reusableFunctions.js';
import ViewOnlyInlineMessage from '../reusable/ViewOnlyInlineMessage/ViewOnlyInlineMessage.js';
import { useUser } from '../../contexts/userContext.js';
import './HomePage.scss';
import { useNameConventions } from '../../contexts/nameConventionsContext.js';

const HomePage = () => {
  const [orgAccess, setOrgAccess] = React.useState([]);
  const { user } = useUser();
  const { nameConventions } = useNameConventions();

  useEffect(() => {
    if (user?.activeOrganization) {
      getOrganizationAccessIcons().then((res) => {
        setOrgAccess(res.data);
      });
    }
  }, [user?.activeOrganization, user?.activeBudget, user?.activeCostCenters]);
  
  return (
    <ForgeScaffold>
      {user && <section className="homepage" slot="body">
        {user?.isViewOnly ? <ViewOnlyInlineMessage style={{top: '58px'}}/> : null}
        <div className="hero">
          <div className="welcomeText">
            <h1 className="forge-typography--display6">
              {messageManager(nameConventions).HOME_PAGE.WELCOME_USER(user)}
            </h1>
            <h2 className="forge-typography--display6 nonBold">
              {getTodaysDate()}
            </h2>
          </div>
        </div>

        <div className="content">
          <div className="cards --forge-spacing-medium">
            {getDashboardCards(nameConventions).map((card) => (
              getAccessCondition(card.accessName, orgAccess, user) && <HomePageCard key={card.title} {...card} />
            ))}
          </div>
        </div>
      </section>}
    </ForgeScaffold>
  );
};

export default HomePage;
